// Home.js
import '../style/home.css';
import { Link } from 'react-router-dom';
import Navbar from '../components/navbar';
import Footer from '../components/footer';

function Home() {
  const years = Array.from({ length: 11 }, (_, i) => 2026 - i);

  const yearFlags = {
    2026: ['🇳🇴'],
    2025: ['🇻🇳', '🇬🇮', '🇨🇭', '🇳🇴', "🇧🇦"], // Vietnam, Gibraltar
    2024: ['🇺🇬', '🇰🇬'], // Uganda, Kyrgyzstan
    2023: ['🇮🇱', '🇱🇺', '🇬🇪'], // Israel, Luxembourg, Georgia
    2022: ['🇲🇽', '🇦🇱', '🇮🇪', '🇲🇪'], // Mexico, Albania, Ireland, Montenegro
    2021: ['🇩🇰'], // Denmark
    2020: ['🇮🇩', '🇭🇷'], // Bali (Indonesia), Croatia
    2019: ['🇯🇴', '🇱🇹', '🇸🇮'], // Jordan, Lithuania, Slovenia
    2018: ['🇨🇷', '🇳🇴'], // Costa Rica, Norway
    2017: ['🇱🇰'], // Sri Lanka
    2016: ['🇨🇻'], // Cape Verde
    2015: ['🇱🇻'], // Latvia
  };
  
  // Render year content with appropriate flags
  const renderYearContent = (year) => {
    const flags = yearFlags[year] || [];
    
    if (flags.length > 0) {
      return (
        <>
          <div className="year-text">{year}</div>
          <div className="flags-container">
            {flags.map((flag, index) => (
              <div key={index} className="flag">{flag}</div>
            ))}
          </div>
        </>
      );
    } else {
      return year;
    }
  };

  return (
    <div className="home">
      <h1>JC World Photos 🌎</h1>
      <div className="year-grid">
        {years.map(year => (
          <Link to={`/${year}`} key={year} className="year-container">
            {renderYearContent(year)}
          </Link>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default Home;